// import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import '@/styles/index.css';
import '@/styles/site.css';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENV,
  enabled: !import.meta.env.DEV,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ['localhost', import.meta.env.VITE_TRACE_PROPAGATION_TARGETS],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

const container = document.getElementById('root');

if (container) {
  ReactDOM.createRoot(container).render(
      <App />
  );
} else {
  console.error('Root element not found.');
}
